export default "__VITE_ASSET__BS2mbf7o__"